<template>
  <v-dialog
    v-model="showModal"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <v-col class="text-right">
        <v-btn
          x-small
          outlined
          light
          color="#546E7A"
          @click="showModal = false"
        >
          <v-icon x-small>
            mdi-close
          </v-icon>
          Close
        </v-btn>
      </v-col>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-map-marker-radius
        </v-icon> Enable Access
      </h2>
      <v-form>
        <v-card-text>
          <v-container fluid>
            <p
              class="fail-message-style"
            >
              <font>
                <v-icon
                  size="30"
                  color="#C62828"
                >
                  mdi-close-thick
                </v-icon>
                {{ errorMessage }}
              </font>
            </p>
            <p
              class="os-style"
            >
              In iOS <br>
              <span class="browser-style">Check this first -</span>
              <font class="content-style">
                Settings -> Privacy & Security -> Location Services -> Select your browser -> Allow
              </font> <br>
              <span class="browser-style">Safari -</span>
              <font class="content-style">
                Settings -> Safari -> Settings for Websites -> Location -> Allow
              </font> <br>
              <span class="browser-style">Chrome/Any Other -</span>
              <font class="content-style">
                Settings -> Chrome/Any Other -> Location -> Allow
              </font>
            </p>
            <p
              class="os-style"
            >
              In Android <br>
              <span class="browser-style">Chrome/Any Other -</span>
              <font class="content-style">
                Settings -> Apps -> Chrome/Any Other -> Permissions -> Location -> Allow
              </font>
            </p>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: 'BrowserLocPermissionSettings',
  props: {
    errorMessage: {
      type: String,
      default: 'User denied the request for location access. Please close the tab and relaunch our app once access is enabled.',
    },
  },
  data () {
    return {
      showModal: true,
    };
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
};
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.os-style {
  font-size: 15px;
  font-weight: bold;
  color: #FF3700;
  font-family:'Times New Roman', Times, serif;
  line-height: 1.5;
}
.browser-style {
  color: #37474F;
  text-decoration: underline;
}
.content-style {
  font-size: 13px;
  font-weight: bold;
  color: #546E7A;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}
.fail-message-style {
  font-size: 14px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
